import { axiosInstance } from '../axios';

const getFewByIdsApi = {
  getCustomersByIds(ids) {
    const url = `/customers/public?format=short&${ids}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getStoresByIds(id) {
    const url = `/stores/?${id}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getDiscountProductsByIds(customerId) {
    const url = `/products?format=full&customerId=${customerId}&status=ENABLED&size=30&page=0`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getProductsByStore(customerId, storeId) {
    const url = `/products?format=full&customerId=${customerId}&sellingStores=${storeId}&size=30&page=0`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getParentProductsByIds(customerId, parentIds) {
    const url = `/products?format=short&customerId=${customerId}&parentId=${parentIds}&size=0&page=0`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getPriceFunctionsCustomerByIds(customerId) {
    const url = `/products/price-functions?format=short&customerId=${customerId}&size=30&page=0`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getNotificationDefinitionFewIds(ids) {
    const addToUrl = ids.reduce((acc, id) => `${acc}&id=${id}`, '');
    const url = `/notification/definitions?format=short${addToUrl}&size=30&page=0`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getNotificationDefinitionByIds(ids) {
    const url = `/notification/definitions?format=short&size=10&page=0&${ids}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getOrdersByCard({ size = 10, page = 1, bin, l4, customer, currency, amount, date }) {
    let url = `/payment-proxy/orders-by-card-digits?format=short&size=${size}&page=${page - 1}`;

    if (bin) {
      url += `&bin=${bin}`;
    }

    if (l4) {
      url += `&l4=${l4}`;
    }

    if (customer) {
      url += `&origin=${customer}`;
    }

    if (currency) {
      url += `&currency=${currency}`;
    }

    if (amount) {
      url += `&amount=${Math.round(amount * 100)}`;
    }

    if (date) {
      url += `&date=${date}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getOrdersByEndUserId(id) {
    const url = `/ordersv2?format=short&endUser.id=${id}&size=500&page=0`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getOrdersBySubscriptionId(id) {
    const url = `/ordersv2/views/orders?subscriptionId=${id}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getExportReportByParamWithFilters(param, filters) {
    const url = `/import-export-manager/export/${param}?separator=,${filters}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getLineitemsByActivationCode(activationCode) {
    const url = `/ordersv2/lineitemdata/?activationCode=${activationCode}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getLineitemsBySubscription(subscriptionId) {
    const url = `/ordersv2/lineitemdata/?subscriptionId=${subscriptionId}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getOrdersByOrdersId(ids = []) {
    let url = '/ordersv2?';

    const filters = ids.map((id) => `id=${id}`);

    url += filters.join('&');

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getCommandsBySubscription(subscriptionId, { page, size, sorting } = {}) {
    let url = `/command-scheduler/api/commands?entity.id=${subscriptionId}&size=${size || 10}&page=${page || 0}`;
    let sort = sorting;

    if (!sorting) {
      sort = { value: 'triggerDate', type: 'asc' };
    }

    url += `&sort=${sort.value},${sort.type}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getEnduserGroupsByIds(ids) {
    const url = `/endusers/groups?${ids}&size=30&page=0`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getCustomerProvidersByName(name) {
    const url = `customers/providers?&name=*${name}*`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getSubscriptionModels({ name }) {
    const url = `/subscription-manager/models?format=short${name ? `&name=${name}` : ''}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getCustomFieldsDefinitionByCustomerId(customerId) {
    const url = `/products/customFieldsDefinition?customerId=${customerId}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getFixedUpgradeRecoPrices(recoId) {
    let url = `/prices?format=short&productRecoId=${recoId}&sort=startDate,asc`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
};

export default getFewByIdsApi;
